<template>
  <div id="app">
    <!-- btn -->
    <div class="btn">
      <div v-if="is_show_btn">
        <el-button
          v-if="!invited_is_edit"
          :class="[sign_is_enable ? '' : 'active']"
          type="primary"
          size="small"
          @click="signType()"
          >{{ sign_is_enable ? "标记为不合适" : "已标记为不合适" }}</el-button
        >

        <el-button
          v-if="sign_is_enable"
          type="primary"
          size="small"
          @click="interView(invitedData)"
          >{{ invited_is_edit ? "查看面试邀请" : "发起面试邀请" }}</el-button
        >
      </div>
      <el-button
        v-if="collect_show_btn"
        :class="[collect_is_type.is_enable ? '' : 'active', 'collect']"
        type="primary"
        size="small"
        @click="collectType()"
        >{{ collect_is_type.is_enable ? "收藏" : "取消收藏" }}</el-button
      >
      <!-- <el-button type="info" size="small" @click="viewR" v-show="show">查看完整简历信息</el-button> -->
      <el-button
        class="online"
        type="primary"
        size="small"
        @click="check('exportR')"
        >导出在线简历</el-button
      >
      <el-button
        class="down"
        v-if="json.allow_download"
        type="success"
        size="small"
        @click="check('downloadR')"
        >下载附件简历</el-button
      >
    </div>
    <!-- 简历组件 -->
    <Resume :data="json"></Resume>
    <!-- dialog -->
    <!-- :before-close="isDialog" -->
    <el-dialog
      custom-class="dialog-prompt"
      :visible.sync="isdialog.show"
      width="30%"
      append-to-body
    >
      <div class="dialog-promp-img">
        <img
          v-if="isdialog.img == 'success'"
          style="width:60px;height:60px;"
          src="@/assets/imgs/dialog-success.png"
        />
        <img
          v-if="isdialog.img == 'error'"
          style="width:60px;height:60px;"
          src="@/assets/imgs/dialog-error.png"
        />
      </div>
      <p>{{ isdialog.title }}</p>
      <p>{{ isdialog.text }}</p>
    </el-dialog>
    <template>
      <Dialog
        :dialogData="dialogData"
        @close-dialogStatus="Close_dialog"
      ></Dialog>
    </template>
  </div>
</template>

<script>
import Resume from "@/components/Resume";
import $api from "@/api/ResumeModule";
import interview from "./components/interview";
import singTypeMes from "./components/signTypeMes";
import Dialog from "@/components/Dialog";
export default {
  components: { Resume, Dialog },
  data() {
    return {
      id: "",
      position_id: "",
      cv_log_id: "",
      json: {},
      show: false,
      is_show_btn: false,
      sign_show_btn: true,
      invited_show_btn: true,
      collect_show_btn: false,
      isdialog: {
        show: false,
        title: "",
        text: "",
        img: ""
      },
      loading: "",
      dialogData: {},
      invitedData: {},
      suitableType: {},
      invited_is_edit: "",
      suitableNum: 0,
      interType: [
        "发起面试邀请",
        "待接受",
        "已接受",
        "已取消",
        "已结束",
        "已拒绝"
      ],
      sign_is_enable: "",
      collect_is_type: ""
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        this.$emit("defaultPath", val.meta.record[1].path);
        if (this.$route.query.id) {
          this.id = this.$route.query.id;
          this.position_id = this.$route.query.position_id;
          this.getData();
        } else {
          this.$router.go(-2);
          throw new Error("TypeError: 简历详情没有id");
        }
      }
    }
  },
  created() {
    if (this.$route.query.cv_log_id) {
      this.cv_log_id = this.$route.query.cv_log_id;
      this.suitable();
      this.getInviteData();
      this.is_show_btn = true;
    }
    if (this.$route.query.position_id) {
      this.collectStatusFun();
      this.collect_show_btn = true;
    }
  },
  mounted() {},
  methods: {
    //获取详情信息
    getData() {
      $api
        .getResumeDetails(this.id)
        .then(data => {
          // console.log(data.data.data)
          this.json = data.data.data;
          this.show = this.json.permission ? false : true;
        })
        .catch(err => {
          // console.log("coming in getResumeDetails error")
          if (err.status === 403) {
            this.$router.go(-2);
          }
        });
    },
    //面试邀约企业信息
    getInviteData() {
      $api
        .getInvited({ cv_log_id: this.cv_log_id })
        .then(data => {
          this.invitedData = data.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    //简历状态详情
    suitable() {
      let params = {
        cv_log_id: this.cv_log_id
      };
      $api
        .deliverStatus(params)
        .then(data => {
          this.suitableType = data.data.data;
          this.suitableNum = data.data.data.invited.status;
          this.sign_is_enable = this.suitableType.suitable.is_enable;
          this.invited_is_edit = data.data.data.invited.id_edit;
        })
        .catch(err => {
          console.log(err);
        });
    },
    //简历收藏状态详情
    collectStatusFun() {
      let params = {
        cv_id: this.id,
        position_id: this.position_id
      };
      $api
        .getCollectStatus(params)
        .then(data => {
          console.log(data.data);
          this.collect_is_type = data.data.data.collect;
        })
        .catch(err => {
          console.log(err);
        });
    },
    //收藏
    collectType() {
      let { id, status } = this.collect_is_type;
      let params = {
        cv_id: this.id,
        position_id: this.position_id,
        collection_id: id,
        is_collection: status == 0 ? 1 : 0
      };

      $api
        .collectStatus(params)
        .then(data => {
          this.$message({
            type: "success",
            message: status == 0 ? "取消收藏成功" : "收藏成功"
          });
          this.collectStatusFun();
        })
        .catch(err => {
          console.log(err);
        });
    },
    //查看完整简历信息
    viewR() {
      $api
        .getResumeDetailsComplete(this.id)
        .then(data => {
          // console.log(data.data.data);
          if (data.data.status == "204") {
            this.tips(
              "温馨提示：您好，您暂未购买相关服务，请联系相关工作人员。谢谢 "
            );
          } else {
            let { name, tel, email } = data.data.data;
            this.json.name = name;
            this.json.tel = tel;
            this.json.email = email;
            this.show = false;
          }
        })
        .catch(err => {
          // console.log("coming in getResumeDetailsComplete error")
          console.log(err);
        });
    },
    //检查是否查看完整简历
    check(prem) {
      this[prem]();
      // if(!this.show){
      //     this[prem]();
      // }else{
      //     this.tips('温馨提示：请先查看完整版简历后导出或下载 ');
      // }
    },

    //导出在线简历
    exportR() {
      let that = this;
      this.isLoading(true, "正在导出简历,请稍后...");
      $api
        .exportResume(this.id,this.cv_log_id)
        .then(data => {
          // console.log(data);
          let blob = new Blob([data.data], {
            type: `application/msword`
          });
          let objectUrl = URL.createObjectURL(blob);
          let link = document.createElement("a");
          let fname = `${this.json.name}.doc`;
          link.href = objectUrl;
          link.setAttribute("download", fname);
          document.body.appendChild(link);
          link.click();
          this.isLoading(false);
          that.isDialog("导出成功", "请前往桌面查看", "success");
        })
        .catch(err => {
          // console.log("coming in exportResume error");
          console.log(err);
          this.isLoading(false);
          that.isDialog(
            "错误提示",
            "该人员暂未完善在线简历，请联系相关人员，谢谢",
            "error"
          );
        });
    },
    //下载附件简历
    downloadR() {
      let that = this;
      this.isLoading(true, "正在下载简历附件,请稍后...");
      $api
        .downloadResume(this.id,this.cv_log_id)
        .then(data => {
          // console.log(data);
          let fileName = data.headers["content-disposition"],
            blob = new Blob([data.data]),
            objectUrl = URL.createObjectURL(blob),
            link = document.createElement("a"),
            fname =
              `${this.json.name}的简历附件` + `.${fileName.split(".")[1]}`;
          link.href = objectUrl;
          link.setAttribute("download", fname);
          document.body.appendChild(link);
          link.click();
          this.isLoading(false);
          that.isDialog("下载成功", "请前往下载中心查看", "success");
        })
        .catch(err => {
          console.log("coming in downloadResume error");
          // console.log(err);
          this.isLoading(false);
          that.isDialog(
            "错误提示",
            "该人员暂未上传附件简历，请联系相关人员，谢谢",
            "error"
          );
        });
    },
    //提示
    isDialog(title, text, img) {
      this.isdialog = {
        show: !this.isdialog.show,
        title: title,
        text: text,
        img: img
      };
    },
    //全屏加载
    isLoading(show, title) {
      const isloading = this.$loading({
        lock: true,
        text: title,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      if (show) {
        return isloading;
      } else {
        return isloading.close();
      }
    },
    //权限提示
    tips(text) {
      this.$message({
        message: text,
        center: true,
        showClose: true,
        duration: 3000,
        type: "warning",
        customClass: "jsjd"
      });
    },
    signType() {
      //已标记
      if (!this.suitableType.suitable.is_enable) {
        return;
      }
      this.dialogData = {
        title: "标记为不合适",
        dialogVisible: true,
        width: "440px",
        buttonNum: true,
        render: (h, scope) => {
          var that = this;
          return this.$createElement(singTypeMes, {
            ref: "cli",
            props: {
              roleData: {},
              dialogType: "suitable"
            },
            on: {
              datamaseg(el, dialogType, istrue) {
                that.istrue = istrue;
                that.dialogType = dialogType;
                that.eaitData = el;
                that.callback_fun();
              }
            }
          });
        }
      };
    },
    interView(data) {
      let { is_enable, id_edit, id } = this.suitableType.invited;
      if (!is_enable) {
        return;
      }
      this.dialogData = {
        title: "发起面试邀请",
        dialogVisible: true,
        width: "790px",
        buttonNum: true,
        render: (h, scope) => {
          var that = this;
          return this.$createElement(interview, {
            ref: "cli",
            props: {
              roleData: data,
              interId: id,
              is_edit: id_edit,
              dialogType: "inter"
            },
            on: {
              datamaseg(el, dialogType, istrue) {
                that.istrue = istrue;
                that.dialogType = dialogType;
                that.interData = el;
                that.callback_fun();
              }
            }
          });
        }
      };
    },
    callback_fun() {
      var that = this;
      //标记简历状态
      if (this.dialogType == "suitable") {
        let params = {
          cv_log_id: this.cv_log_id,
          is_suitable: 0
        };
        $api
          .suitableStatus(params)
          .then(data => {
            this.$message({
              type: "success",
              message: "已标记为不合适"
            });
            that.dialogData["dialogVisible"] = false;
            this.suitable();
          })
          .catch(err => {
            console.log(err);
          });
      }
      //面试邀约
      if (this.dialogType == "inter") {
        this.getSuitableFun();
      }
    },
    getSuitableFun() {
      $api
        .getSuitable(this.interData)
        .then(data => {
          this.$message({
            type: "success",
            message: this.invited_is_edit
              ? "面试邀请修改成功"
              : "已成功发起面试邀请"
          });
          this.dialogData["dialogVisible"] = false;
          this.suitable();
          this.getInviteData();
        })
        .catch(err => {
          this.$message.error(err.data.error);
          console.log(err);
        });
    },
    Close_dialog() {
      //处理组件
      this.$refs.cli.Submission("suitable");
    }
  }
};
</script>

<style scoped>
#app {
}
/* btn */
.btn {
  position: fixed;
  top: 317px;
  right: 20px;
  width: 120px;
  padding: 15px 8px;
  z-index: 999;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0px 1px 8px 0px rgba(0, 61, 118, 0.2);
}
.btn button {
  width: 100%;
  margin: 0 0 10px;
  color: #132234;
  height: 37px;
  background: #f5f7fd;
  border: none;
  position: relative;
}

.btn button::after {
  content: "";
  width: 4px;
  height: 37px;
  text-align: center;
  border-radius: 3px;
  position: absolute;
  left: 0;
  top: 0;
}
.btn > div button:nth-child(1):after {
  background: #f74a4a;
}
.btn > div button:nth-child(1):hover {
  color: #fff;
  background: #f74a4a;
}
.btn > div button:nth-child(2):after {
  background: #00cf8d;
}
.btn > div button:nth-child(2):hover {
  color: #fff;
  background: #00cf8d;
}
.btn .collect:after {
  background: #ffa825;
}
.btn .collect:hover {
  color: #fff;
  background: #ffa825;
}

.btn .online:after {
  background: #0077ff;
}
.btn .online:hover {
  color: #fff;
  background: #0077ff;
}
.btn .down {
  margin-bottom: 0;
}
.btn .down:after {
  background: #249e77;
}
.btn .down:hover {
  color: #fff;
  background: #249e77;
}
.btn button.active {
  color: #fff;
  background: #414365;
}
.btn button.active:hover {
  color: #fff;
  background: #414365;
}
</style>
<style>
.el-message--warning {
  background: rgba(226, 248, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(123, 215, 255, 1);
}
.el-message.is-closable .el-message__content {
  padding-right: 24px;
}
.el-message .el-icon-warning {
  color: #1991ff;
}
.el-message--warning .el-message__content {
  color: #12749f;
  font-size: 12px;
}
.el-icon-close {
  margin-left: 8px import;
}
</style>



// WEBPACK FOOTER //
// src/views/resume/resumedetails.vue